import React, { Fragment } from 'react';
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { has, get } from 'lodash';
import { push } from 'react-router-redux';
import { compose } from 'recompose';
import { withRouter, Link } from 'react-router-dom';
import { Image } from 'semantic-ui-react';
import styled from 'styled-components';
import { User } from './constant';
import { isMobileAgent, HHAlert } from '../common/util';
import { ALERT_TYPE } from '../common/constant';
import { userLogout, updateUserPermission } from '../actions';
import { reset } from '../actions/chat';
import { retrieveNotifications } from '../actions/notification';
import { StyledList, NavButton } from './index';

const Avatar = ({
  avatarUrl, bgColor, firstName, lastName
}) => {
  if (avatarUrl) {
    return (
      <Image avatar src={avatarUrl} size='tiny' />
    );
  } else if (bgColor && firstName && lastName) {
    const initial = [firstName.charAt(0).toUpperCase(), lastName.charAt(0).toUpperCase()].join('');
    return (

      <DefaultAvatar bgColor={bgColor}>
        <div>{initial}</div>
      </DefaultAvatar>

    );
  }
  return (
    <Image
      src={User.defaultNavIcon}
      alt='Avatar'
      size='tiny'
    />

  );
};

export const MemoizedAvatar = React.memo(Avatar);


class UserAvatarDropdown extends React.Component {
  state = { navActive: false };

  componentWillMount() {
    if (has(this.props.user, 'profile.basicInfo')) {
      this.props.retrieveNotifications({ token: this.props.user.token });
    }
  }

  // 20220803 Kevin quick fix for avatar got re-render when scroll
  // TODO: fix so avatar is only fetched once
  // shouldComponentUpdate(nextProps, nextState) {
  //   if ((this.state.navActive && !nextState.navActive) || (!this.state.navActive && nextState.navActive)) {
  //     return true;
  //   }
  //   if (window.innerWidth >= 768) {
  //     if (window.scrollY >= 56 && !this.state.navColor) {
  //       return true;
  //     } return false;
  //   }
  //   if (window.scrollY >= 69 && !this.state.navColor) {
  //     return true;
  //   } return false;
  // }

  handleOnClickCreateEvent = () => {
    const isMobile = isMobileAgent();
    if (isMobile) {
      HHAlert({ id: 'mobileAgent' }, ALERT_TYPE.ERROR);
    } else {
      this.props.updateUserPermission(() => { this.props.push('/admin/create-event'); });
    }
  }

  handleOnClickManageEvents = () => {
    const isMobile = isMobileAgent();
    if (isMobile) {
      HHAlert({ id: 'mobileAgent' }, ALERT_TYPE.ERROR);
    } else {
      this.props.updateUserPermission(() => { this.props.push('/admin'); });
    }
  }

  handleLogout = () => {
    this.props.reset();
    this.props.userLogout();
  }

  render() {
    const { translate, user } = this.props;
    const { path } = this.props.match;
    const isHomePage = path === '/';

    const isMobile = isMobileAgent();

    const userRole = get(user, 'profile.basicInfo.signUpRole') || get(user, 'profile.basicInfo.signupRole');
    const firstName = get(user, 'profile.basicInfo.firstName', false);
    const lastName = get(user, 'profile.basicInfo.lastName', false);
    const bgColor = get(user, 'profile.basicInfo.bgColor', false);
    const avatarUrl = get(user, 'profile.basicInfo.avatarUrl', false);

    const helpGuideUrl = (process.env.REACT_APP_SERVER_ENV === 'production' && process.env.REACT_APP_SERVER_TARGET === 'cn') ? 'https://help.hackhub.cn/' : 'https://help.hackhub.com';

    return (
      <Fragment>
        <ListWrapper className={`globalHeader_list_item${this.state.navActive ? ' active' : ''}`} data-item='profile'>
          <a
            onClick={() => {
              this.setState({ navActive: !this.state.navActive });
            }}
            onMouseEnter={() => {
              if (!isMobile) this.setState({ navActive: true });
            }}
            onMouseLeave={() => this.setState({ navActive: false })}
          >
            <AvatarWrapper isHomePage={isHomePage ? !this.props.navColor : false}>
              {/* <Avatar /> */}
              <MemoizedAvatar
                avatarUrl={avatarUrl} bgColor={bgColor} firstName={firstName}
                lastName={lastName}
              />
            </AvatarWrapper>
          </a>
          <SelectorBlock
            className='globalHeader_list_item_dropnav'
            onMouseEnter={() => {
              if (!isMobile) this.setState({ navActive: true });
            }}
            onMouseLeave={() => this.setState({ navActive: false })}
          >
            <SelectorItem>
              <a href={`/u/${get(user, 'profile.basicInfo.username')}`}>
                {translate('my profile')}
              </a>
            </SelectorItem>
            <SelectorItem>
              <a onClick={() => this.props.push('/user/tickets')}>
                {translate('my tickets')}
              </a>
            </SelectorItem>
            <SelectorItem>
              <a
                href={helpGuideUrl}
                target='_blank'
                rel='noopener noreferrer'
              >
                {translate('user guide')}
              </a>
            </SelectorItem>
            {
              userRole === 'Organizer' && (
                <SelectorItem>
                  <a onClick={this.handleOnClickManageEvents}>
                    {translate('site navbar manage events')}
                  </a>
                </SelectorItem>
              )
            }
            <SelectorItem>
              <a onClick={this.handleLogout} >
                {translate('site.navbar.logout')}
              </a>
            </SelectorItem>
          </SelectorBlock>
        </ListWrapper>

        <MobileNavMenu>
          <StyledList>
            <a href={`/u/${get(user, 'profile.basicInfo.username')}`}>
              {translate('my profile')}
            </a>
          </StyledList>
          <StyledList>
            <Link to='/user/tickets'>
              {translate('my tickets')}
            </Link>
          </StyledList>
          <StyledList>
            <a
              href={helpGuideUrl}
              target='_blank'
              rel='noopener noreferrer'
            >
              {translate('user guide')}
            </a>
          </StyledList>
          {
            userRole === 'Organizer' && (
              <StyledList>
                <a onClick={this.handleOnClickManageEvents}>
                  {translate('site navbar manage events')}
                </a>
              </StyledList>
            )
          }
          <StyledList>
            <NavButton
              isPrimary={false} isSmall label={translate('site.navbar.logout')}
              onClick={this.handleLogout}
              isHomePage={false}
            />
          </StyledList>
        </MobileNavMenu>
      </Fragment>
    );
  }
}

const SelectorBlock = styled.ul`
  width: 240px;
  background: #FFFFFF;
  border: 1.5px solid #D9E1E7;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  list-style-type: none;
  padding: 0;
  overflow: hidden;
  position: absolute;
  right: 0;
  && li:last-child {
    border: none;
    margin-top: 0;
    padding-top: 0;
  }
`;

const SelectorItem = styled.li`
  background: #FFFFFF;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #06152B;
  &:hover a {
    background: #D9E1E7;
    color: #0090FF;
  } 
`;

const ListWrapper = styled.li`
  position: relative;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const MobileNavMenu = styled.ul`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block; 
  }

  @media only screen and (max-width: 387px) {
    li {
      font-size: 14px;
    }
  }
`;

const AvatarWrapper = styled.div`
  width: 42px;
  height: 42px;
  border: 1px solid #fff;
  border-radius: 50%;
  border: ${props => (props.isHomePage ? '1px solid #fff' : '1px solid #0094FB')};


  &&& img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

`;

const DefaultAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #fff;

  div {
    width: 36px;
    height: 36px;
    margin: 1px;
    border-radius: 50%;
    background: ${(props) => props.bgColor};
    color: #fff;
    display: flex;
    justify-content:center;
    align-items:center;
  }
`;

export default compose(
  withLocalize,
  withRouter,
  connect(
    ({ user, notifications }) => ({ user, notifications }),
    {
      push, userLogout, retrieveNotifications, updateUserPermission, reset
    }
  )
)(UserAvatarDropdown);



// WEBPACK FOOTER //
// ./src/components/nav/userAvatarDropdown.js